import {AdobeAn} from './intro'
import { gsap } from 'gsap'

export default function headerInit($, fillColor = '#ffffff'){

  var canvas, stage, exportRoot, anim_container, fnStartAnimation;

  // Header logo canvas animation
  function init() {
    canvas = document.getElementById('header-canvas');
    anim_container = document.getElementById('header-canvas-wrapper');
    // dom_overlay_container = document.getElementById('dom_overlay_container');
    var comp=AdobeAn.getComposition('D3BF8FFD1A924633B375DE9F0FCF18B6');
    // var lib=comp.getLibrary();
    AdobeAn.setHeader(true);
    AdobeAn.setFillColor(fillColor);

    window.intramotev = window.intramotev || {};

    handleComplete({},comp);
  }

  function handleComplete(evt, comp) {
    //This function is always called, irrespective of the content. You can use the variable "stage" after it is created in token create_stage.
      var lib=comp.getLibrary();
    // var ss=comp.getSpriteSheet();
    exportRoot = new lib.iEVlogoanimation1a();

    stage = new lib.Stage(canvas);
    //Registers the 'tick' event listener.
    fnStartAnimation = function() {
      stage.addChild(exportRoot);
      createjs.Ticker.framerate = lib.properties.fps;
      createjs.Ticker.addEventListener('tick', stage);
    }

    //Code to support hidpi screens and responsive scaling.
    AdobeAn.makeResponsive(false,'both',false,1,[canvas,anim_container], stage);
    AdobeAn.compositionLoaded(lib.properties.id);

    fnStartAnimation();

    addUserInteraction()
  }

  function addUserInteraction() {

    /**
     * Menu toggling
     */
    let openMenuTl = gsap.timeline({ defaults: { ease: 'power1.inOut' }, paused: true, 
      onComplete:() => $('#nav-toggle-button').attr('aria-expanded', 'true'),
      onReverseComplete:() => $('#nav-toggle-button').attr('aria-expanded', 'false')
    })
    openMenuTl.to('#main-menu-wrapper', {autoAlpha: 1, duration: 0})
    openMenuTl.to('#main-menu-backdrop', {autoAlpha: 1, duration: 0.5})
    openMenuTl.to('#main-menu', {x: 0, duration: 0.3}, '>-.2')
    openMenuTl.from('.main-nav li', {x: 30, opacity: 0,  duration: 0.2, stagger: 0.1}, '>')

    const numberOfSections = document.querySelectorAll('section').length
    $("a[href='#contact']").on('click', (e) => { 
      e.preventDefault()
      openMenuTl.reverse()
        window.setTimeout(function(){
          if (window.intramotev.gotoSection) {
            intramotev.gotoSection(numberOfSections, false) 
          } else {
            $('html, body').animate({
              scrollTop: $("footer").offset().top
            }, 1000);
          }
        }, 500);
    })

    $('#nav-toggle-button').on('click', () => {
      openMenuTl.restart()
    })

    $('#close-menu-button, #main-menu-backdrop').on('click', () => { 
      openMenuTl.reverse()
    })

    /**
     * Keyboard up and down arrows``
     */
    $(document).keydown(function(e) {
      if (intramotev.gotoSection && !intramotev.animating) {
        if (e.code === 'ArrowDown') {
          e.preventDefault();
          intramotev.gotoSection(intramotev.currentIndex + 1, true)
        }
        else if (e.code === 'ArrowUp') {
          e.preventDefault();
          intramotev.gotoSection(intramotev.currentIndex - 1, false)
        }
      }
    });
  }

  init()
}
